const summaryTemplate = require('./view/summary.handlebars');
const SUMMARY_SELECTOR: string = '[data-summary]';

export interface ISummaryPrice {
  retailPrice: number;
  retailPriceFormatted: string;
  status: string;
  totalPrice: number;
  totalPriceFormatted: string;
}

export default class Summary {
  // Amount of choosed slots
  public slots: number = 0;

  // Value of the selected location
  public location: number = 0;

  // id of choosed duration
  public duration: { amount: number, id: number } = {amount: 0, id: 0};

  // id for the choosed game
  public gameId: number = 0;

  // Price object
  public price: ISummaryPrice;

  // Base element
  private $base: JQuery;

  public constructor() {
    this.$base = $(SUMMARY_SELECTOR);
  }

  public enableLoading() {
    this.$base.parents('.row').addClass('is-loading');
  }

  public disableLoading() {
    this.$base.parents('.row').removeClass('is-loading');
  }

  public render() {
    this.$base.html(summaryTemplate({
      slots: this.slots,
      duration: this.duration,
      vat: this.$base.data('vat'),
      translations: this.$base.data('translations'),
      price: this.price.totalPriceFormatted,
    }));
  }
}
